import { useState } from "preact/hooks";
import { usePurchasedProducts } from "@/hooks/usePurchasedProducts";
import { BuyAgainPanel } from "./BuyAgainPanel";
import { ToastContainer } from "./Toast";
import { Logo } from "./Logo";

const PLACEHOLDER_IMAGE = "https://socialocean.co/placeholder.png";

export function BuyAgainWidget() {
  const [isOpen, setIsOpen] = useState(false);
  const { data: products, isLoading: productsLoading } = usePurchasedProducts();

  if (productsLoading || !products || products.length === 0) {
    return null;
  }

  const firstImage = products[0]?.image_url ?? PLACEHOLDER_IMAGE;

  return (
    <>
      {isOpen ? (
        <BuyAgainPanel
          isOpen={isOpen}
          onClose={() => setIsOpen(false)}
          products={products}
          productsLoading={productsLoading}
        />
      ) : (
        <div className="tw:fixed tw:bottom-2 tw:inset-e-2 tw:z-50 tw:bg-transparent">
          <button
            onClick={() => setIsOpen(true)}
            className="tw:rounded-2xl  tw:p-3 tw:flex tw:flex-col tw:items-center tw:cursor-pointer tw:transition-shadow hover:tw:shadow-[0px_7px_29px_0px_rgba(100,100,111,0.35)] tw:gap-1 tw:border-none"
            aria-label="Open buy again"
          >
            {/* eslint-disable-next-line @next/next/no-img-element */}
            <img
              src={firstImage}
              alt=""
              className="tw:size-10 tw:rounded-lg tw:object-cover tw:shrink-0"
            />
            <Logo className="tw:w-12" />
          </button>
        </div>
      )}
      <ToastContainer />
    </>
  );
}
